import type { ProductFeatureTypes } from './ProductFeature';
import ProductFeature from './ProductFeature';
import { ProductFeaturesWrapper } from './ProductFeatureList.styles';

export type ProductFeatureListProps = {
  subTechnologies?: ProductFeatureTypes[];
};

export function ProductFeatureList({ subTechnologies }: ProductFeatureListProps) {
  return (
    <ProductFeaturesWrapper>
      <ul>
        {subTechnologies?.map((subTechnology, idx) => (
          <ProductFeature subTechnology={subTechnology} key={`product-subTechnology-${idx}`} />
        ))}
      </ul>
    </ProductFeaturesWrapper>
  );
}

export default ProductFeatureList;
